/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: authoring-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const View = require('lib/@waca/core-client/js/core-client/ui/core/View');
import React from 'react';
import ReactDOM from 'react-dom';
import PaletteListing from '../components/PaletteListing';

const PaletteListingView = View.extend({
	init: function (options, container) {
		PaletteListingView.inherited('init', this, arguments);
		this.container = container;
		this.options = options;
	},
	render: function () {
		ReactDOM.render( (
			<PaletteListing
				paletteService={this.options.paletteService}
				getPalettes={this.options.getPalettes}
				onCreatePalette={this.options.onCreatePalette}
				onChange={this.options.onChange}
				mruComponentIdentifier={this.options.mruComponentIdentifier}
				selectedId={this.options.selectedId}
				createPaletteType={this.options.createPaletteType}
			/>
		), this.container );
	},
	remove: function () {
		ReactDOM.unmountComponentAtNode( this.container );
	}
});

export default PaletteListingView;


// WEBPACK FOOTER //
// ./src/js/views/PaletteListingView.js